import styled from 'styled-components'

// Status stamp (BHV-039) — the Angular page renders a grunge
// "APPROVED"/"DENIED" stamp graphic. No DS primitive exists; a bordered
// label using the success/danger tokens stands in.
export const StatusStampStyled = styled.div<{
  $variant: 'approved' | 'denied'
}>`
  display: inline-block;
  padding: ${({ theme }) => `${theme.space.xsmall} ${theme.space.medium}`};
  border: 3px solid
    ${({ theme, $variant }) =>
      $variant === 'approved' ? theme.colors.success : theme.colors.danger};
  border-radius: ${({ theme }) => theme.typography.pxToRem(4)};
  color: ${({ theme, $variant }) =>
    $variant === 'approved' ? theme.colors.success : theme.colors.danger};
  font-size: ${({ theme }) => theme.typography.pxToRem(24)};
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  text-transform: uppercase;
`
